import { NavigationClient } from '@azure/msal-browser'
// import  { RouteRecordRaw } from 'vue-router'
// import  { NavigationOptions } from '@azure/msal-browser'
// import  { Router } from 'vue-router'


/**
 * Override MSAL route navigation
 */
export class VueNavigationClient extends NavigationClient {

  constructor (router) {
    super()
    this.router = router
  }

  /**
   * Only called during redirects
   */
  navigateExternal (url, options) {
    return super.navigateExternal(url, options)
  }

  /**
   * Only called during popup completion
   */
  async navigateInternal (url, options) {
    const path = url.replace(location.origin, '')
    options.noHistory
      ? await this.router.replace(path)
      : await this.router.push(path)
    return true
  }
}
